"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _NotificationPreferences = require("./NotificationPreferences");
Object.keys(_NotificationPreferences).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _NotificationPreferences[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _NotificationPreferences[key];
    }
  });
});